/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Feedback202,
  PostApiV1Feedback400,
  PostApiV1Feedback401,
  PostApiV1Feedback500,
  PostApiV1FeedbackMutationRequest,
  PostApiV1FeedbackMutationResponse,
} from "../../types/feedbackRegistroController/PostApiV1Feedback.ts";
import { createFeedbackRequestViewModelSchema } from "../createFeedbackRequestViewModelSchema.ts";
import { feedbackViewModelSchema } from "../feedbackViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Feedback202Schema = z.lazy(
  () => feedbackViewModelSchema,
) as unknown as ToZod<PostApiV1Feedback202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Feedback400Schema =
  z.any() as unknown as ToZod<PostApiV1Feedback400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Feedback401Schema =
  z.any() as unknown as ToZod<PostApiV1Feedback401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Feedback500Schema =
  z.any() as unknown as ToZod<PostApiV1Feedback500>;

export const postApiV1FeedbackMutationRequestSchema = z.lazy(
  () => createFeedbackRequestViewModelSchema,
) as unknown as ToZod<PostApiV1FeedbackMutationRequest>;

export const postApiV1FeedbackMutationResponseSchema = z.lazy(
  () => postApiV1Feedback202Schema,
) as unknown as ToZod<PostApiV1FeedbackMutationResponse>;
